/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { Markdown } from '@storybook/addon-docs/blocks';

/**
 * Creates a Storybook docs page component that renders markdown content (e.g. a README.md).
 *
 * Requires the `autodocs` tag on the component meta to create a Docs entry in the sidebar
 * (the global preview config disables autodocs with `!autodocs`).
 *
 * Usage in a *.stories.tsx file:
 * ```ts
 * import ReadmeContent from '../README.md?raw';
 * import { createReadmeDocsPage } from '../../_common/readme-docs-page';
 *
 * const meta: Meta = {
 *   // ...
 *   tags: ['docsPage', 'autodocs'],
 *   parameters: {
 *     docs: { page: createReadmeDocsPage(ReadmeContent) },
 *   },
 * };
 * ```
 */
function stripMarkdownComments(content: string): string {
  return content.replace(/^\[\/\/\]: #.*\n*/gm, '');
}

export function createReadmeDocsPage(markdownContent: string) {
  const cleaned = stripMarkdownComments(markdownContent);
  return function ReadmeDocsPage() {
    return <Markdown>{cleaned}</Markdown>;
  };
}
